import { render } from "./ComplianceScoreWidget.vue?vue&type=template&id=36ec94e1&scoped=true"
import script from "./ComplianceScoreWidget.vue?vue&type=script&lang=js"
export * from "./ComplianceScoreWidget.vue?vue&type=script&lang=js"

import "./ComplianceScoreWidget.vue?vue&type=style&index=0&id=36ec94e1&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36ec94e1"]])

export default __exports__